/* Spintronik Produktseite: Variantenwahl, die sich selbst zurechtruecken kann,
   dazu die Pruefung der Pflichtfelder im Fahrzeugformular. */
(function () {
  function starte(w) {
    if (!w || w.dataset.gestartet === 'ja') return;
    w.dataset.gestartet = 'ja';

    var quelle = w.querySelector('[data-varianten]');
    if (!quelle) return;
    var daten = JSON.parse(quelle.textContent);
    var reihen = Array.prototype.slice.call(w.querySelectorAll('.knoepfe'));
    var feldId = w.querySelector('[data-id]');
    var preis = w.querySelector('[data-preis]');
    var kaufen = w.querySelector('[data-kaufen]');
    var liefer = w.querySelector('[data-lieferzeit]');
    var waehrung = w.dataset.waehrung || 'EUR';
    var text = {
      da: w.dataset.textLieferzeit || '',
      weg: w.dataset.textWeg || 'Nicht verfuegbar',
      kauf: w.dataset.textKauf || 'In den Warenkorb'
    };

    function format(cent) {
      try {
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: waehrung }).format(cent / 100);
      } catch (e) {
        return (cent / 100).toFixed(2) + ' ' + waehrung;
      }
    }

    function auswahl() {
      return reihen.map(function (r) {
        var b = r.querySelector('button[aria-pressed="true"]');
        return b ? b.dataset.wert : null;
      });
    }

    function passt(v, wahl) {
      for (var i = 0; i < wahl.length; i++) {
        if (wahl[i] !== null && v.werte[i] !== wahl[i]) return false;
      }
      return true;
    }

    function setzen(werte) {
      reihen.forEach(function (r, stelle) {
        Array.prototype.forEach.call(r.querySelectorAll('button'), function (b) {
          b.setAttribute('aria-pressed', b.dataset.wert === werte[stelle] ? 'true' : 'false');
        });
      });
    }

    function auffrischen() {
      var wahl = auswahl();

      // Werte, die zur uebrigen Auswahl nicht passen, werden gedaempft,
      // bleiben aber anklickbar. Der Rest rueckt dann nach.
      reihen.forEach(function (r, stelle) {
        Array.prototype.forEach.call(r.querySelectorAll('button'), function (b) {
          var probe = wahl.slice();
          probe[stelle] = b.dataset.wert;
          b.dataset.fern = daten.some(function (v) { return passt(v, probe); }) ? 'nein' : 'ja';
        });
      });

      var treffer = daten.filter(function (v) { return passt(v, wahl); })[0];
      if (treffer) {
        if (feldId) feldId.value = treffer.id;
        galerieAufVariante(treffer.id);
        if (preis) preis.textContent = format(treffer.preis);
        if (kaufen) {
          kaufen.disabled = !treffer.da;
          kaufen.textContent = treffer.da ? text.kauf : text.weg;
        }
        if (liefer) liefer.innerHTML = treffer.da ? '<b>&#9679;</b> ' + text.da : '';
        if (history.replaceState) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', treffer.id);
            history.replaceState({}, '', u.toString());
          } catch (e) {}
        }
      } else if (kaufen) {
        kaufen.disabled = true;
        kaufen.textContent = text.weg;
        if (liefer) liefer.innerHTML = '';
      }
    }

    reihen.forEach(function (r, stelle) {
      r.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;

        var wahl = auswahl();
        wahl[stelle] = b.dataset.wert;

        // Gibt es zu dieser Zusammenstellung nichts, ruecken die anderen
        // Angaben auf die naechste passende Zusammenstellung nach.
        if (!daten.some(function (v) { return passt(v, wahl); })) {
          var ersatz = daten.filter(function (v) { return v.werte[stelle] === b.dataset.wert; })[0];
          if (ersatz) wahl = ersatz.werte.slice();
        }

        setzen(wahl);
        auffrischen();
      });
    });

    var feld = w.querySelector('.menge input');
    var minus = w.querySelector('[data-minus]');
    var plus = w.querySelector('[data-plus]');
    if (minus && feld) minus.addEventListener('click', function () { feld.value = Math.max(1, (parseInt(feld.value, 10) || 1) - 1); });
    if (plus && feld) plus.addEventListener('click', function () { feld.value = (parseInt(feld.value, 10) || 1) + 1; });

    var streifen = w.querySelector('.streifen');

    // Ein Vorschaubildchen gross zeigen. Der Klick auf den Streifen und der
    // Variantenwechsel gehen beide durch diese eine Stelle, damit die
    // Galerie nur eine einzige Anzeigelogik hat.
    function zeigeBildchen(b) {
      if (!b || !streifen) return;
      var haupt = w.querySelector('.buehne img');
      if (haupt) haupt.src = b.dataset.gross;
      Array.prototype.forEach.call(streifen.querySelectorAll('button'), function (x) { x.removeAttribute('aria-current'); });
      b.setAttribute('aria-current', 'true');
    }

    // Zuordnung Varianten-ID zu Bild-ID, kommt aus dem Liquid.
    var variantenbilder = {};
    try { variantenbilder = JSON.parse(w.dataset.variantenbilder || '{}'); } catch (e) { variantenbilder = {}; }

    // Galerie auf das Bild der Variante schalten. Hat die Variante kein
    // eigenes Bild oder fehlt dazu ein Vorschaubildchen, bleibt alles so,
    // wie es ist.
    function galerieAufVariante(id) {
      if (!streifen) return;
      var bildId = variantenbilder[id];
      if (!bildId) return;
      zeigeBildchen(streifen.querySelector('button[data-medien-id="' + bildId + '"]'));
    }

    if (streifen) {
      streifen.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        zeigeBildchen(b);
      });
    }

    // Fahrzeugformular: leere Pflichtfelder halten die Bestellung auf.
    // Wir pruefen selbst, statt uns auf die Browsermeldung zu verlassen,
    // damit die Meldung deutsch, sichtbar und an der richtigen Stelle ist.
    var formular = w.querySelector('[data-formular]');
    if (formular) {
      var pflicht = Array.prototype.slice.call(formular.querySelectorAll('[data-pflicht]'));

      if (pflicht.length) {
        // Der Browser wuerde sonst eine eigene Blase zeigen, die wir nicht
        // gestalten koennen. Deshalb schalten wir sie ab.
        formular.setAttribute('novalidate', 'novalidate');

        formular.addEventListener('submit', function (e) {
          var erstes = null;
          pflicht.forEach(function (el) {
            var leer = !el.value || !String(el.value).trim();
            var kasten = el.closest('.angabe');
            if (kasten) kasten.classList.toggle('fehlt', leer);
            if (leer && !erstes) erstes = el;
          });
          if (erstes) {
            e.preventDefault();
            try { erstes.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (x) { erstes.scrollIntoView(); }
            erstes.focus({ preventScroll: true });
          }
        });

        function entwarnen(e) {
          var kasten = e.target && e.target.closest ? e.target.closest('.angabe') : null;
          if (kasten && e.target.value && String(e.target.value).trim()) kasten.classList.remove('fehlt');
        }
        formular.addEventListener('input', entwarnen);
        formular.addEventListener('change', entwarnen);
      }
    }

    auffrischen();
  }

  function alle() { document.querySelectorAll('.spintronik-produkt').forEach(starte); }
  document.addEventListener('DOMContentLoaded', alle);
  alle();
  document.addEventListener('shopify:section:load', function (e) {
    var w = e.target.querySelector('.spintronik-produkt');
    if (w) { w.dataset.gestartet = ''; starte(w); }
  });
})();